export * from './RankingCustomCatchmentSpan'
